import { useEffect, useRef, useCallback } from 'react'
import { useAuthStore } from '../store/authStore'

export function useWebSocket(onMessage) {
  const ws    = useRef(null)
  const user  = useAuthStore(s => s.user)
  const token = useAuthStore(s => s.token)

  useEffect(() => {
    if (!user?.tenant_id || !token) return

    const proto = location.protocol === 'https:' ? 'wss' : 'ws'
    const url = `${proto}://${location.host}/ws/${user.tenant_id}?token=${token}`
    const socket = new WebSocket(url)
    ws.current = socket

    socket.onmessage = (e) => {
      try { onMessage?.(JSON.parse(e.data)) } catch {}
    }

    // Keepalive ping cada 25s
    const ping = setInterval(() => {
      if (socket.readyState === WebSocket.OPEN) socket.send('ping')
    }, 25000)

    return () => {
      clearInterval(ping)
      socket.close()
    }
  }, [user?.tenant_id, token])

  const send = useCallback((msg) => {
    if (ws.current?.readyState === WebSocket.OPEN)
      ws.current.send(JSON.stringify(msg))
  }, [])

  return { send }
}
